import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

import { SubmissionScore } from '@module/assignment';
import styled from '@xstyled/styled-components';
import { Tooltip } from 'antd';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { getSize, getColor, styleVariables } from '@lib/common';
import { ScoreInput, getAnswerStatusColorTooltip } from '@module/assignment-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledAnswerItem = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: ", ";\n  width: 100%;\n  margin-bottom: ", ";\n"])), getSize('padding8'), getSize('padding8'));
var IndexCircle = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: ", ";\n  height: ", ";\n  border-radius: 50%;\n  background-color: ", ";\n  color: ", ";\n  margin-right: ", ";\n  font-size: ", ";\n  font-weight: 700;\n  line-height: 1;\n  flex-shrink: 0;\n"])), getSize('padding24'), getSize('padding24'), getColor('fillIntActive'), getColor('fillBgWhite'), getSize('padding8'), getSize('typo12'));
var StyledBlankContent = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  flex: 1;\n"])), getSize('padding8'));
var StyledAnswerText = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: ", " ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  color: #334155;\n  font-size: ", ";\n  border: 1px solid\n    ", ";\n  min-width: 200px;\n"])), getSize('padding4'), getSize('padding8'), getSize('radiusSm'), function (_ref) {
  var $status = _ref.$status;
  if ($status === 'correct') return getColor('successBgActive');
  if ($status === 'manuallyAwarded') return '#FFF7E6';
  if ($status === 'incorrect' || $status === 'skipped') return getColor('errorBgActive');
  return '#f1f5f9';
}, getSize('typo14'), function (_ref2) {
  var $status = _ref2.$status;
  if ($status === 'correct') return getColor('successActive');
  if ($status === 'manuallyAwarded') return styleVariables.colors.gold1;
  if ($status === 'incorrect' || $status === 'skipped') return getColor('errorActive');
  return '#cbd5e1';
});
var StyledStatusIcon = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: ", ";\n  flex-shrink: 0;\n"])), getSize('typo16'), function (_ref3) {
  var $status = _ref3.$status;
  if ($status === 'correct') return getColor('successActive');
  if ($status === 'manuallyAwarded') return styleVariables.colors.gold1;
  if ($status === 'incorrect' || $status === 'skipped') return getColor('errorActive');
  return '#94a3b8';
});
var StyledScoreInputContainer = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  padding: 1px;\n  flex-shrink: 0;\n"])));
var AnswerStatus;

(function (AnswerStatus) {
  AnswerStatus["Correct"] = "correct";
  AnswerStatus["Incorrect"] = "incorrect";
  AnswerStatus["Skipped"] = "skipped";
  AnswerStatus["ManuallyAwarded"] = "manuallyAwarded";
})(AnswerStatus || (AnswerStatus = {}));

var getScoreInputValue = function getScoreInputValue(score) {
  return score !== SubmissionScore["default"].value ? score : null;
};

var getAnswerStatus = function getAnswerStatus(fillInBlankQuestionAnswer, answerBlank, isSubmissionSubmitted) {
  var _answerBlank$value;

  if (!(answerBlank !== null && answerBlank !== void 0 && answerBlank.value) || ((_answerBlank$value = answerBlank.value) === null || _answerBlank$value === void 0 ? void 0 : _answerBlank$value.text) === '') {
    if (isSubmissionSubmitted) {
      return AnswerStatus.Skipped;
    }

    return undefined;
  }

  var isCorrect = answerBlank.value.text.toLowerCase() === fillInBlankQuestionAnswer.description.toLowerCase();

  if (isCorrect) {
    return AnswerStatus.Correct;
  }

  if (answerBlank.hasGraded() && typeof answerBlank.score === 'number' && answerBlank.score > 0) {
    return AnswerStatus.ManuallyAwarded;
  }

  return AnswerStatus.Incorrect;
};

export var FillInBlankGradingAnswers = function FillInBlankGradingAnswers(_ref4) {
  var _fillInBlankGroupAnsw;

  var fillInBlankQuestion = _ref4.fillInBlankQuestion,
      fillInBlankGroupAnswer = _ref4.fillInBlankGroupAnswer,
      label = _ref4.label,
      isSubmissionSubmitted = _ref4.isSubmissionSubmitted,
      submitGradeAnswer = _ref4.submitGradeAnswer,
      disabled = _ref4.disabled,
      updatedAnswerId = _ref4.updatedAnswerId,
      isPreviewMode = _ref4.isPreviewMode,
      _ref4$isShowingScoreI = _ref4.isShowingScoreInput,
      isShowingScoreInput = _ref4$isShowingScoreI === void 0 ? true : _ref4$isShowingScoreI;

  var renderScoreInput = function renderScoreInput(fillInBlankCorrectAnswer, answerBlank, submitBlankScore) {
    if (!isShowingScoreInput) return null;
    var scoreValue = getScoreInputValue(answerBlank.score);
    var isGraded = answerBlank.hasGraded();
    var isDisabled = disabled || updatedAnswerId === answerBlank.id.toString();

    var scoreInput = /*#__PURE__*/_jsx(StyledScoreInputContainer, {
      children: /*#__PURE__*/_jsx(ScoreInput, {
        questionScore: fillInBlankCorrectAnswer.score || 0,
        label: label,
        submitScore: submitBlankScore,
        value: scoreValue,
        disabled: isPreviewMode || isDisabled,
        active: isGraded,
        danger: isGraded && answerBlank.score === 0
      })
    });

    if (isPreviewMode) {
      return /*#__PURE__*/_jsx(Tooltip, {
        title: label.disabledScoreInputText,
        children: scoreInput
      });
    }

    return scoreInput;
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: fillInBlankGroupAnswer === null || fillInBlankGroupAnswer === void 0 ? void 0 : (_fillInBlankGroupAnsw = fillInBlankGroupAnswer.answers) === null || _fillInBlankGroupAnsw === void 0 ? void 0 : _fillInBlankGroupAnsw.map(function (answerBlank, index) {
      var _answerBlank$value2;

      var foundQuestionAnswer = fillInBlankQuestion.answers.find(function (answer) {
        return answer.id.toString() === answerBlank.answerBlankId;
      });
      var fillInBlankCorrectAnswer = fillInBlankQuestion.correctAnswers.find(function (correctAnswer) {
        return correctAnswer.answerId === answerBlank.answerBlankId;
      });
      var answerStatus = getAnswerStatus(foundQuestionAnswer, answerBlank, isSubmissionSubmitted);
      var displayValue = (answerBlank === null || answerBlank === void 0 ? void 0 : (_answerBlank$value2 = answerBlank.value) === null || _answerBlank$value2 === void 0 ? void 0 : _answerBlank$value2.text) || (answerStatus === AnswerStatus.Skipped ? '-' : '');

      var submitBlankScore = function submitBlankScore(score) {
        if (submitGradeAnswer) {
          submitGradeAnswer(score, answerBlank.id.toString());
        }
      };

      return /*#__PURE__*/_jsxs(StyledAnswerItem, {
        children: [/*#__PURE__*/_jsx(IndexCircle, {
          children: fillInBlankQuestion.index + index
        }), /*#__PURE__*/_jsx(Tooltip, {
          title: getAnswerStatusColorTooltip(answerStatus, {
            correct: label.colorStatusCorrect,
            incorrect: label.colorStatusIncorrect,
            customGrade: label.colorStatusCustomGrade,
            skipped: label.colorStatusSkipped
          }),
          children: /*#__PURE__*/_jsxs(StyledBlankContent, {
            children: [/*#__PURE__*/_jsx(StyledAnswerText, {
              $status: answerStatus,
              children: displayValue
            }), answerStatus && /*#__PURE__*/_jsxs(StyledStatusIcon, {
              $status: answerStatus,
              children: [(answerStatus === AnswerStatus.Correct || answerStatus === AnswerStatus.ManuallyAwarded) && /*#__PURE__*/_jsx(CheckCircleOutlined, {}), (answerStatus === AnswerStatus.Incorrect || answerStatus === AnswerStatus.Skipped) && /*#__PURE__*/_jsx(CloseCircleOutlined, {})]
            })]
          })
        }), renderScoreInput(fillInBlankCorrectAnswer, answerBlank, submitBlankScore)]
      }, answerBlank.answerBlankId);
    })
  });
};